import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { DocumentSettings } from "../../../../models/document-settings";
import { useTheme } from "@emotion/react";
import { useGetDocumentsSettingsQuery } from "../../api/documentsSettings.api";

type DocumentListObject = {
  id: number;
  name: string | null;
  link: string;
  state: {}
};

function AddDocumentMenu() {
  
  // const { data, isLoading, isError, error, refetch } = useGetManufacturersTableQuery()

  const { data: documentsSettings } = useGetDocumentsSettingsQuery();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [documentsList, setDocumentsList] = useState<DocumentListObject[]>();
  const theme = useTheme();

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(()=>{
    if(documentsSettings){
      setDocumentsListState(documentsSettings);
    }
  }, [documentsSettings]);


  function setDocumentsListState( documentsSettings: DocumentSettings[]){

    const list: DocumentListObject[] | undefined = documentsSettings.map(
      (documentSettings: DocumentSettings) => {
        return {
          id: documentSettings.id,
          name: documentSettings.name ?? "",
          link: `/documents/add?documentType=${documentSettings.id}`,
          state: {
            breadcrumbData: [
              {
                name: "מסמכים",
                link: `/documents`
              },
              {
                name: "הוספת מסמך"
              },
              {
                name: documentSettings.name
              }
            ]
          }
          
        };
      }
    );

    setDocumentsList(list);

    return list;
  };

  return (
    <>
      <Tooltip title="הוספת מסמך">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
          sx={{ color: theme.colors.main_color }}
        >
          <NoteAddIcon />
        </IconButton>
      </Tooltip>

      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              //   maxHeight: 50 * 4.5,
              //   width: "20ch",
              direction: "rtl",
              textAlign: "right",
            },
          },
          //   list: {
          //     'aria-labelledby': 'long-button',
          //   },
        }}
      >
        {documentsList?.map((option) => (
          <MenuItem
            key={option.id}
            onClick={handleClose}
            component={RouterLink}
            to={option.link}
            state={option.state}
          >
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default AddDocumentMenu;
